import { useContext, useEffect } from "react";
import { Button, Paper, Typography } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
type ChangeParamsType = {
  target: { value: any; name: string };
  name: string;
};
import { useForm } from "react-hook-form";
import { ClaimContext, ClaimContextType } from "..";
import { useMutation, useQuery } from "react-query";
import { Search } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import {
  getInsuranceByParams,
  getInsuranceType,
  getPostOffice,
} from "../../services";
import moment from "moment";
import { ClaimSearchSubmitType, initialData } from "../types";
const today = moment(new Date()).format("yyyy-MM-DD");
const fieldsForClear = ["insuranceType", "receiver", "payer"];
let initialClaimListingParams = initialData;
function SearchArea() {
  const { setFilter, filter, setRefetch } = useContext(
    ClaimContext,
  ) as ClaimContextType;
  const { handleSubmit, watch, control, resetField, reset } =
    useForm<ClaimSearchSubmitType>({
      defaultValues: initialClaimListingParams,
    });
  const insType = watch("insuranceType");
  const location = useLocation();
  const isClaimListingPage = location.pathname.includes(
    "/insurance/claim-listing",
  );

  const { data: insuranceType, isLoading: insuranceTypeLoading } = useQuery(
    ["insuranceTypesForClaimlisting"],
    getInsuranceType,
    { refetchOnWindowFocus: false },
  );

  const {
    mutate: getReveiverByType,
    data: receiverData,
    isLoading: receiverLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: getPayerByType,
    data: payerData,
    isLoading: payerLoadig,
  } = useMutation(getInsuranceByParams);

  const { data: postOffice, isLoading: postOfficeLoading } = useQuery(
    ["fetchPostOfficeForClaimList"],
    getPostOffice,
    {
      refetchOnWindowFocus: false,
    },
  );

  const clearField = (index: number) => {
    for (let i = index; i < fieldsForClear.length; i++) {
      resetField(fieldsForClear[i] as keyof typeof initialClaimListingParams);
    }
  };

  function onSubmit(value: ClaimSearchSubmitType) {
    // console.log(value);
    localStorage.setItem("claimListingParams", JSON.stringify(value));
    setFilter({
      ...filter,
      date: value.fromDate,
      toDate: value?.toDate,
      postOfficeId: value?.postoffice?.poId
        ? Number(value?.postoffice?.poId)
        : 0,
      insuranceType: value.insuranceType?.name || "",
      receiver: value?.receiver?.name || value?.payer?.name || "",
      payer: value.payer?.name || "",
      all: value.all || false,
    });
    setRefetch(true);
  }

  const handleInsurnceTypeChange = (params: ChangeParamsType) => {
    const {
      target: { value },
    } = params;
    clearField(1);
    const allData = watch();
    if (Boolean(value)) {
      if (value.id == 1) {
        getReveiverByType({ typeId: value.id });
      } else {
        getPayerByType({ typeId: value.id });
      }
      setFilter((prev) => ({
        ...prev,
        all: false,
      }));
      reset({
        ...allData,
        all: false,
      });
    } else {
      setFilter((prev) => ({
        ...prev,
        all: true,
      }));
      reset({
        ...allData,
        insuranceType: null,
        all: true,
      });
    }
  };

  const handleReset = () => {
    if (postOffice?.response) {
      reset({
        ...initialClaimListingParams,
        postoffice: postOffice.response[0],
        all: true,
      });
    }
    setFilter((prev) => ({
      ...prev,
      all: true,
    }));
  };

  useEffect(() => {
    const paramsData = JSON.parse(localStorage.getItem("claimListingParams") || JSON.stringify(initialClaimListingParams));
    if (postOffice?.response) {
      reset({
        ...initialClaimListingParams,
        fromDate: paramsData?.fromDate || initialClaimListingParams.fromDate,
        toDate: paramsData?.toDate || initialClaimListingParams.toDate,
        postoffice:paramsData?.postoffice || postOffice.response[0],
        all: true,
      });
    }
  }, [postOffice]);

  return (
    <div>
      <Paper className="p-2">
        <div className="pb-2 border-b">
          <Typography fontSize={14} fontWeight={"bold"}>
            {isClaimListingPage ? "Claim list search" : "Report search"}
            <Search />
          </Typography>
          {/* <Button onClick={handleClick}>click</Button> */}
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-5 gap-3 pt-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date", inputProps: { max: today } }}
            rules={{ required: "From date required" }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "To date required" }}
          />
          <CustomFormField
            control={control}
            options={insuranceType?.response || []}
            loading={insuranceTypeLoading}
            element="autocomplete"
            name="insuranceType"
            fieldProps={{ label: "Insurance Type" }}
            autocompleteProps={{
              isOptionEqualToValue: (option, value) => option.id == value.id,
              getOptionLabel: (option) => option.name,
            }}
            rules={{
              required: false,
              onChange: handleInsurnceTypeChange,
            }}
          />
          <div className={insType?.id == 1 ? "" : "hidden"}>
            <CustomFormField
              control={control}
              options={receiverData?.response || []}
              loading={receiverLoadig}
              element="autocomplete"
              name="receiver"
              fieldProps={{ label: "Receiver" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              rules={{
                required: false,
                onChange: () => {
                  clearField(2);
                  getPayerByType({ typeId: 2 });
                },
              }}
            />
          </div>
          <div>
            <CustomFormField
              control={control}
              options={payerData?.response || []}
              loading={payerLoadig}
              element="autocomplete"
              name="payer"
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              fieldProps={{
                label: insType?.id == 1 ? "Payer" : "Insurance",
              }}
              rules={{
                required: false,
              }}
            />
          </div>
          <CustomFormField
            options={postOffice?.response || []}
            loading={postOfficeLoading}
            control={control}
            element="autocomplete"
            name="postoffice"
            fieldProps={{ label: "Post Office" }}
            rules={{ required: false }}
            autocompleteProps={{
              isOptionEqualToValue: (option, value) =>
                option.poId == value.poId,
              getOptionLabel: (option) => option.poName,
            }}
          />
          <div className="hidden">
            <CustomFormField
              control={control}
              name="all"
              element="checkbox"
              fieldProps={{ label: "All" }}
              rules={{ required: false }}
            />
          </div>
          <div
            className={
              insType?.id == 1
                ? "col-span-4 flex justify-end gap-2 items-center"
                : "col-span-5 flex justify-end gap-2 items-center"
            }
          >
            <Button size="small" type="submit">
              search
            </Button>
            <Button
              onClick={handleReset}
              size="small"
              type="reset"
              color="error"
            >
              clear
            </Button>
          </div>
        </form>
      </Paper>
    </div>
  );
}

export default SearchArea;
